import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { UserProvider, useUser } from './contexts/UserContext';
import AdminLayout from 'layouts/Admin.js';
import BasicLayout from 'layouts/Basic.js';
import Spinner from 'react-bootstrap/Spinner';
import logo from 'assets/img/SONICmedia.png';
import config from './config';
import { cognitoHostedUILogin } from './services/auth';

function AppRoutes() {
    const { user, loading, authError, layout } = useUser();

    // Show spinner while checking auth
    if (loading) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center h-100">
                    <div className="card">
                        <div className="card-header">
                            <img className="logo-login" src={logo} alt="Sonic Media" />
                        </div>
                        <div className="card-body d-flex justify-content-center align-items-center">
                            <Spinner className="spinner yellow-primary-color" animation="border" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Show error with retry
    if (authError) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center h-100">
                    <div className="card" style={{ height: 'auto' }}>
                        <div className="card-header">
                            <img className="logo-login" src={logo} alt="Sonic Media" />
                        </div>
                        <div className="card-body">
                            <p className="mfa-prompt">{authError}</p>
                            <div className="form-group">
                                <button onClick={() => cognitoHostedUILogin()} className="btn login_btn">
                                    Try Again
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Not authenticated — Cognito redirect is handling it
    if (!user) {
        return null;
    }

    // Authenticated — render both layout routes
    const defaultRedirect = layout === 'Admin' ? '/admin/resonicadmins' : config.defaultPath;

    return (
        <Switch>
            <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
            <Route path="/manage" render={(props) => <BasicLayout {...props} />} />
            <Redirect from="/" to={defaultRedirect} />
        </Switch>
    );
}

function App() {
    return (
        <UserProvider>
            <BrowserRouter>
                <AppRoutes />
                <ToastContainer theme="colored" autoClose={2000} />
            </BrowserRouter>
        </UserProvider>
    );
}

export default App;
